import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Scanline } from './Scanline';
const faqs = [{
  question: 'Does it work with my dialer?',
  answer: "Yes. Recall is completely dialer-agnostic — it works with RingCentral, Dialpad, Five9, Zoom, Teams, and any other phone system. As long as the call audio plays through your computer, the app can capture your microphone and the borrower's system audio. No integrations or IT setup required."
}, {
  question: 'Is it recording everything I do?',
  answer: 'No. The app only captures when you manually start a capture session, and a visible indicator shows whenever it is listening. When you stop capture — or never start it — nothing is recorded. Capture is entirely user-controlled.'
}, {
  question: 'Can I delete my calls and borrower data?',
  answer: 'Yes. You can delete individual calls, transcripts, or entire borrower profiles at any time. Your conversation history is yours to keep — or remove — on your terms.'
}, {
  question: 'Is this a tool for monitoring my team?',
  answer: "No. Recall is built for the loan officer's own memory. It's a personal desktop AI notetaker that helps you remember your own borrower conversations — your private business call notes, not a management dashboard."
}, {
  question: 'How accurate are the AI notes?',
  answer: 'Notes are generated from a full transcript of the call and tuned for mortgage conversations — income, credit, property details, documents, and follow-ups. Every answer and summary links back to the source call and transcript excerpt, so you can always verify against what was actually said.'
}, {
  question: 'What platforms are supported?',
  answer: "The Recall Windows app is coming soon. Request early access and we'll notify you the moment it's ready to download — and let you know when other platforms follow."
}, {
  question: 'Does it replace my CRM?',
  answer: 'No — it complements whatever you already use. Recall focuses on one thing: capturing and organizing what was actually said in your borrower conversations, so the details behind every deal are never lost.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="relative scroll-mt-16 border-t border-slate-100 py-20 lg:py-28" data-id="element-95">
      <Scanline data-id="element-96" />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-98">
          <p className="font-mono-brand text-xs uppercase tracking-[0.2em] text-teal-600" data-id="element-99">
            FAQ
          </p>
          <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-ink sm:text-4xl" data-id="element-100">
            Frequently asked questions
          </h2>
        </motion.div>

        <div className="mt-12 divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-101">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.question} data-id="element-102">
                <h3 data-id="element-103">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} id={`faq-button-${i}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left hover:bg-slate-50 transition-colors" data-id="element-104">
                    <span className="font-display text-base font-semibold text-slate-900" data-id="element-105">
                      {faq.question}
                    </span>
                    <span className="font-mono-brand flex-none text-sm font-bold text-teal-600" data-id="element-106">
                      {isOpen ? '[–]' : '[+]'}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-107">
                  {isOpen && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-button-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-108">
                      <p className="px-6 pb-5 text-sm leading-7 text-slate-600" data-id="element-109">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}